import baseMixin from './baseMixin'
import { tween, stagger } from 'popmotion'

export default {
    mixins: [baseMixin],

    beforeCreate() {
        this.baseElementQueryString = 'custom-visuals-graphic'
    },

    methods: {
        setStyler() {
            this.starStylers = this.stylerGroup('path')
        },

        initAction() {
            return tween({ from: 1, to: 0 })
        },

        animationAction() {
            return stagger(
                [
                    ...this.starStylers.map(_ =>
                        tween({ from: 0, to: 1, duration: 500 })
                    )
                ],
                300
            )
        },

        initReaction(v) {
            this.starStylers.forEach(styler => styler.set({ opacity: v }))
        },

        animationReaction(values) {
            values.forEach((v, i) => this.starStylers[i].set({ opacity: v }))
        }
    }
}
